import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

export function createMatPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();

  intl.itemsPerPageLabel = 'Éléments par page :';
  intl.nextPageLabel = 'Page suivante (Alt + →)';
  intl.previousPageLabel = 'Page précédente (Alt + ←)';
  intl.firstPageLabel = 'Première page (Alt + Shift + ←)';
  intl.lastPageLabel = 'Dernière page (Alt + Shift + →)';

  intl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 sur ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} – ${endIndex} sur ${length}`;
  };

  return intl;
}

export const provideMatPaginatorIntl = (): EnvironmentProviders =>
  makeEnvironmentProviders([{ provide: MatPaginatorIntl, useFactory: createMatPaginatorIntl }]);
